<script setup lang="ts">
import { computed } from 'vue';
import { EMPTY_FIELD_SIGN } from '../forms/utils';
import { I18nKey } from '@/utils/typings';
import NumericValueField from '../forms/dataTypes/NumericValueField.vue';
import { NumericValueDto } from '@/api/generator';

const props = defineProps<{
  value?: NumericValueDto[];
}>();

const items = computed(() => {
  return props.value?.map((quantity) => ({
    title: quantity?.name || EMPTY_FIELD_SIGN,
    quantity: quantity,
  }));
});
</script>

<template>
  <div class="d-flex ga-6">
    <div v-for="item in items" :key="item.title">
      <v-label class="text-justify">{{ $t(item.title as I18nKey) }}</v-label>
      <NumericValueField :modelValue="item.quantity" mode="details" />
    </div>
  </div>
</template>
